module.exports = __webpack_public_path__ + "media/applicants/google-play-fr-303fa03f.png";